import { Vue, i18n } from "Common/vue";
import switchComponent from "Components/vue/ModalSwitch/Main";
import switchStore from "Components/vue/ModalSwitch/store/index";

$(document).on("show.bs.modal", "#switch-modal", function (event) {
    const trigger = event.relatedTarget;
    const modalData = Object.assign({}, trigger?.dataset || {});

    const modal = document.querySelector(".js-switch-modal");
    const isCartEmpty = modal?.dataset.emptyCart === "true";

    if (window.$_switch) {
        switchStore.commit("SET_MODAL_DATA", modalData);
        switchStore.dispatch("fetchAddresses");
    } else {
        window.$_switch = new Vue({
            i18n,
            store: switchStore,
            render: (h) =>
                h(switchComponent, {
                    props: {
                        shopType: Eshop.options.shopType,
                        emptyCart: isCartEmpty,
                        modalData,
                    },
                }),
        }).$mount(".js-switch-modal");
    }
});

$(document).on("hide.bs.modal", "#switch-modal", function () {
    setCookie("first-visit", "1", 1);

    if (document.querySelector(".l-base").classList.contains("is-first-visit")) {
        document.querySelector(".l-base").classList.remove("is-first-visit");
    }
});

rEvent.on("Custom.Cart.addedItem", function () {
    if (document.querySelector(".js-force-address-modal")) {
        $("#switch-modal")
            .modal({
                backdrop: "static",
                keyboard: false,
            })
            .modal("show");

        $("#switch-modal").append('<div class="c-modal-fake-backdrop"></div>');
    }
});
